/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Configurar mi pack',
              link: URLS.PACK_CONFIG,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'Lo sentimos, no podemos ofrecerte este producto',
          msg: [
            'Para contratar Solución FTTR Movistar necesitas tener un Pack miMovistar y cobertura fibra.',
          ],
          errorName: 'producto incompatible',
        },
      },
      OFFER_WITH_SOME_DEPENDENCIES: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          link: {
            label: 'Localizar mi tienda más cercana',
            url: URLS.SEARCH_SHOP,
          },
          title: 'Tras revisar tus datos, no podemos ofrecerte este producto en movistar.es',
          msg: ['Lo sentimos, para contratar Solución FTTR Movistar debes ir a una Tienda Movistar'],
          errorName: 'oferta con varias dependencias posibles',
        },
      },
      FUSION_MANDATORY: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Lo sentimos, no podemos ofrecerte este producto',
          msg: [
            'Para añadir este producto es necesario contratar un pack miMovistar',
          ],
          buttons: [
            {
              link: URLS.PACK_CONFIG,
              label: 'Ver productos miMovistar',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'fusión requerido',
        },
      },
      INCOMPATIBLE_PRODUCT_BY_ZONE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Tras revisar tus datos, no podemos ofrecerte este producto',
          msg: [
            'Lo sentimos, para contratar Solución FTTR debes tener contratado miMovistar o Fusión',
          ],
          buttons: [
            {
              link: URLS.PACK_CONFIG,
              label: 'Configurar miMovistar',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con zona',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
